<template>
	<div class="item-panel">
		<label class="item-label" :class="{required: isShowRequired}">{{text}}</label>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "ItemPanel",
	props: ["text", "isRequired"],
	data() {
		return {
			isShowRequired: this.isRequired || false
		}
	}
}
</script>

<style scoped lang="scss">
	.item-panel {
		display: flex;
		margin-bottom: 16px;

		.item-label {
			position: relative;
			padding-left: 10px;
			margin-right: 8px;
			margin-top: 8px;
			min-width: 66px;
		}
		.required::before {
			content: "*";
			color: #fe0931;
			display: block;
			position: absolute;
			top: 3px;
			left: -1px;
		}
	}
</style>